<div class="modal-content">
  <div class="modal-header bg-primary-100">
    <h5 class="modal-title">{{ header }}</h5>
  </div>
  <div class="modal-body">
    <p markdown>{{ message }}</p>
    <div class="mt-2">
      <label class="mb-1" for="confirm-input">Enter the word "CONFIRM" to Proceed</label>
      <input
        type="text"
        class="form-control"
        id="confirm-input"
        name="confirm-input"
        [(ngModel)]="confirmationInput"
        placeholder='Enter "CONFIRM" to proceed...'
      />
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-between">
    <button type="button" class="btn btn-secondary" (click)="onConfirm(false)">Cancel</button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="onConfirm(true)"
      [disabled]="confirmationInputEnteredIncorrectly()"
    >
      Confirm
    </button>
  </div>
</div>
